import {
  AlertProps,
  Box,
  BoxProps,
  Flex,
  Heading,
  ImageProps,
  TextProps,
} from "@chakra-ui/react";
import { DateSelector, MovieCard, MovieCardListSkeleton } from "../../modules";

import { MovieCardProps } from "../../@types/MovieCard";
import { AlertMessage, Image } from "../../components";
import DynamicGrid from "../../components/DynamicGrid";
import { NO_MOVIE } from "../../constant/alertMessage";
import { DEFAULT_IMAGE_FALLBACK } from "../../constant/placeholders";

function MovieWithDateFilter({
  title,
  movies,
  onDateChange,
  isLoading,
  dateSelectorMaxDays = 5,
  titleProps,
  movieDateWithFilterFlexProps,
  alertMessageProps,
  pageHeaderProps,
  headerImageProps,
  headerTextProps,
  showDateSelector = true,
  ...props
}: {
  title: string;
  movies: MovieCardProps[];
  onDateChange: (date: Date) => void;
  isLoading?: boolean;
  toShowGenre?: boolean;
  dateSelectorMaxDays?: number;
  titleProps?: TextProps;
  movieDateWithFilterFlexProps?: BoxProps;
  alertMessageProps?: AlertProps;
  pageHeaderProps?: {
    image?: string;
    headerText?: string;
  };
  headerImageProps?: ImageProps;
  headerTextProps?: TextProps;
  showDateSelector?: boolean;
}) {
  return (
    <Box my="2rem">
      {pageHeaderProps && (
        <Box
          display={"flex"}
          sx={{
            display: "flex",
            justifyContent: "center",
            mb: "20px",
            height: "fit-content",
            alignItems: "flex-end",
          }}
        >
          {pageHeaderProps.image && (
            <Image
              maxW="14rem"
              id="brand_logo"
              className="navbar__brand__logo"
              src={pageHeaderProps.image}
              fallbackSrc={DEFAULT_IMAGE_FALLBACK}
              alt="Logo"
              height={{
                base: "2rem",
                sm: "3rem",
                md: "3rem",
                xl: "3rem",
              }}
              {...headerImageProps}
            />
          )}
          {pageHeaderProps.headerText && (
            <Heading
              color="primary.500"
              textTransform={"uppercase"}
              {...headerTextProps}
            >
              {pageHeaderProps.headerText}
            </Heading>
          )}
        </Box>
      )}
      <Flex
        justifyContent={{
          base: "center",
          md: "space-between",
        }}
        gap={{
          base: "1rem",
          md: "0",
        }}
        wrap="wrap"
        {...movieDateWithFilterFlexProps}
      >
        <Heading
          textTransform="uppercase"
          fontSize={{ base: "16px" }}
          {...titleProps}
        >
          {title}
        </Heading>
        {showDateSelector && (
          <DateSelector
            noOfDays={dateSelectorMaxDays}
            onDateChange={onDateChange}
            {...props}
          />
        )}
      </Flex>
      {isLoading ? (
        <MovieCardListSkeleton />
      ) : movies.length < 1 ? (
        <AlertMessage
          message={NO_MOVIE}
          sx={{
            mt: "1rem",
          }}
          {...alertMessageProps}
        />
      ) : (
        <DynamicGrid baseChildKey="movie__card__" {...props}>
          {movies?.map((movie, index: number) => (
            <MovieCard key={`movie__card___${index}`} {...movie} {...props} />
          ))}
        </DynamicGrid>
      )}
    </Box>
  );
}

export default MovieWithDateFilter;
